export default class Command {
    constructor(item) {
      this.id = item != null ? item.id : '';
      this.companyId = item != null ? item.companyId : '';
      this.emailAddress = item != null ? item.emailAddress.address : '';
      this.firstName = item != null ? item.firstName : '';
      this.lastName = item != null ? item.lastName : '';
      this.customerRelationId = item != null ? item.customerRelationId : '';
      this.password = '';
      this.confirmPassword = '';
      this.groupIds = [ "769BA936-08DD-4960-A0D9-D6F1BF84C5AA" ]
    }
}
